import { useEffect, useMemo, useState, useCallback } from 'react';
import axios from 'axios';

import {
    MaterialReactTable,
    MRT_ToggleDensePaddingButton,
    MRT_ToggleFiltersButton,
    MRT_ToggleFullScreenButton,
    MRT_ToggleGlobalFilterButton,
    useMaterialReactTable,
} from 'material-react-table';

import {
    Box, Chip, IconButton, Menu, MenuItem, Skeleton, Typography,
    Tooltip, Stack, ToggleButton, ToggleButtonGroup, Divider, Paper, Grid,
} from '@mui/material';

import { PieChart, Pie, Cell, Tooltip as ReTooltip, Legend, ResponsiveContainer } from 'recharts';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextField from '@mui/material/TextField';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import { mkConfig, generateCsv, download } from 'export-to-csv';

const csvConfig = mkConfig({ fieldSeparator: ',', decimalSeparator: '.', useKeysAsHeaders: true });

// ─────────────────────────────────────────────────────────────────
const IK = ({ orgId }) => {


    return (
        <Box>
            {/* Header */}
            <Stack direction="row" alignItems="center" justifyContent="space-between" my={1} mb={2}>
                <Typography variant="h6">IK</Typography>
            </Stack>

        </Box>
    );
};

export default IK;